import {
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  Grid,
  MenuItem,
  Select,
  Skeleton,
  Slide,
  styled,
  Drawer,
} from '@mui/material';
import CircleIcon from '@mui/icons-material/Circle';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import SkipNextIcon from '@mui/icons-material/SkipNext';

import { Close, PlayCircle } from '@mui/icons-material';

export const ItemBox = styled(Grid)(({ theme, noPadding, noShadow }) => ({
  backgroundColor: theme.palette.background.paper,
  border: noShadow ? 'none' : `1px solid ${theme.palette.divider}`,
  borderRadius: '8px',
  padding: noPadding ? '0px' : '16px',
}));

export const ProductionBox = styled('div')({
  border: '1px solid var(--status-green-border)',
  backgroundColor: 'var(--status-green-bg)',
  padding: '2px 12px',
  color: 'var(--status-green-color)',
  borderRadius: '4px',
  marginRight: '8px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
});

export const GreenCircle = styled(CircleIcon)({
  height: '14px',
  width: 'auto',
  color: 'var(--status-green-color)',
  marginRight: '8px',
});

export const DownArrow = styled(ArrowDownwardIcon)({
  height: '24px',
  width: 'auto',
});

export const RunIcon = styled(PlayCircle)({
  height: '22px',
  width: 'auto',
  marginRight: '6px',
});

export const Text = styled('span')(({ textColor, fontWeight }) => ({
  fontSize: '14px',
  color: textColor,
  fontWeight: fontWeight,
}));

export const CustomGrid = styled(Grid)(({ vertical, horizontal }) => ({
  display: 'flex',
  alignItems: vertical,
  justifyContent: horizontal,
}));

export const TriggerTitle = styled('div')({
  fontSize: '18px',
  lineHeight: '24px',
});

export const TriggerDescription = styled('div')({
  fontSize: '14px',
  lineHeight: '24px',
});
